import { useState, useEffect } from 'react';
import useEvents from './hooks/useEvents';
import SmallLoader from '@/src/Common/components/SmallLoader';
import NavBar from '@/src/Common/components/NavBar';
import { Heading, Subheading } from '@/src/tailwindui/heading';
import romrLogo from '../../romr_logo.png';
import clickerboothLogo from '../../clickerbooth_logo.png';
import moment from 'moment-timezone';
export default function EventDashboardFrame({
    children,
    navLocation,
    activationId,
}: {
    children: React.ReactNode;
    navLocation: string;
    activationId: string;
}) {
    const { getEventDetails } = useEvents();
    const [isRomr, setIsRomr] = useState(false);
    const [isClickerBooth, setIsClickerBooth] = useState(false);
    const [eventName, setEventName] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventLocation, setEventLocation] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const navItems = [
        {
            name: 'Dashboard',
            route: `/events/${activationId}`,
            current: navLocation === 'dashboard',
        },
        {
            name: 'Details',
            route: `/events/${activationId}/details`,
            current: navLocation === 'details',
        },
        {
            name: 'Experience',
            route: `/events/${activationId}/experience`,
            current: navLocation === 'experience',
        },
        {
            name: 'Sharing',
            route: `/events/${activationId}/sharing`,
            current: navLocation === 'sharing',
        },
    ];

    console.log(navItems);

    useEffect(() => {
        let isMounted = true;
        const fetchEventDetails = async () => {
            setIsLoading(true);
            const eventDetails = await getEventDetails(Number(activationId));

            if (!isMounted) return;
            if (eventDetails) {
                setIsRomr(eventDetails.isRomr);
                setIsClickerBooth(eventDetails.isClickerbooth);
                setEventName(eventDetails.eventDetails.name);
                setEventDate(eventDetails.eventDetails.date);
                setEventLocation(eventDetails.eventDetails.location);
            }
            setIsLoading(false);
        };
        fetchEventDetails();

        return () => {
            isMounted = false;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <SmallLoader />
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-4xl">
            <div className="flex flex-wrap items-end justify-between gap-4 transition-all duration-300 w-full">
                <div className="flex flex-col w-full">
                    <Heading className="text-4xl md:text-5xl">
                        Event Dashboard
                    </Heading>
                    <div className="flex items-start gap-2 flex-row w-full">
                        <div className="flex items-start gap-2 flex-col">
                            <Subheading className="whitespace-nowrap">
                                {eventName}
                            </Subheading>
                            <p className="text-sm text-gray-500 whitespace-nowrap">
                                {eventDate
                                    ? moment(eventDate).format('MMM Do, YYYY')
                                    : ''}
                            </p>
                            {eventLocation && (
                                <p className="text-sm text-gray-500 whitespace-nowrap">
                                    {eventLocation}
                                </p>
                            )}
                        </div>
                        <div className="flex w-full items-end gap-2 flex-row justify-end mt-4">
                            {isRomr && (
                                <img
                                    src={romrLogo}
                                    alt="Romr Logo"
                                    className="h-[24px] scale-75 clickable cursor-pointer object-contain pe-logo justify-self-end"
                                />
                            )}
                            {isClickerBooth && (
                                <img
                                    src={clickerboothLogo}
                                    alt="ClickerBooth Logo"
                                    className="h-40px clickable cursor-pointer object-contain pe-logo justify-self-end"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="my-10 mt-6" />

            <NavBar navItems={navItems} />
            {children}
        </div>
    );
}
